export enum PayableActionType {
    APPROVAL_ONLY = 'approvalOnly',
    SCHEDULE = 'schedulePayment',
    MARK_PAID = 'markPaid',
    SAVE_DRAFT = 'saveDraft'
}

export enum PaymentMethod {
    VENDOR_DECIDE = 'vendorDecide',
    MAIL_CHECK = 'mailCheck',
    PRINT_CHECK = 'printCheck',
    ACH_TRANSFER = 'treasuryAch',
}

export enum PaymentSchedule {
    IMMEDIATE = 'immediately',
    NO_EARLIER_THAN = 'noEarlierThan',
}

export enum PaymentRecordType {
    MATCH = 'match',
    CREATE = 'create',
}

/** SD-9003: what happens to a matched journal entry at mark-as-paid. Mirrors core's JournalEntryMatchAction. */
export enum JournalEntryMatchAction {
    KEEP = 'keep',
    REPLACE = 'replace',
}
